import { useMemo } from "react";
import { useIntl } from "react-intl";
import messages from "./messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  const result = useMemo(() => {
    const translations = {
      title: formatMessage(messages.title),
      btnSubmit: formatMessage(messages.btnSubmit),
      btnCancel: formatMessage(messages.btnCancel),
    };

    return { translations };
  }, [formatMessage]);

  return result;
};
export default useTranslations;
